import { handleActions } from 'redux-actions';
import { measuredCookieReduxKey, cookieKey } from './constants';
import { initializeMeasuredCookie } from './actions';
import { MeasuredCookie } from './MeasuredCookie';
const actionHandler = handleActions({
    [initializeMeasuredCookie.toString()]: (state, { payload })=>payload && payload.cookies[cookieKey] ? MeasuredCookie.decode(payload.cookies[cookieKey]) : state
}, {});
export default {
    [measuredCookieReduxKey]: actionHandler
};
